import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { useControlContext } from '@/contexts/ControlContext';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const ControlDetailsView = () => {
  const { mode } = useDetailMode(DETAIL_TYPE.CONTROL);
  const { form, readOnly, setFormByKey } = useControlContext();
  const { detailChanges } = form;

  const handleChange = ({ target }) =>
    setFormByKey('detailChanges', target.value);

  return (
    <Card className="flex mb-4">
      <CardHeader className="pb-6 grow">
        <div className="flex gap-4 items-start justify-between">
          <CardTitle className="text-base font-medium w-36">
            Details of Change
          </CardTitle>
          <CardDescription className="grow">
            {mode === DETAIL_MODE.STATIC ? (
              detailChanges
            ) : (
              <Textarea
                autoResize
                className="font-mono resize-none"
                disabled={readOnly}
                onChange={handleChange}
                placeholder={'Click here to add details'}
                value={detailChanges}
              />
            )}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};

export default ControlDetailsView;
